import React, { PureComponent } from "react";
import "./TopBar.css";
import logo from "../../assets/images/logo.png";
import spc from "../../assets/images/spc-logo.png";

class TopBar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="top__main">
        <img src={logo} alt="logo" className="top__logo" />
        <img src={spc} alt="logo" className="top__spc" />
      </div>
    );
  }
}

export default TopBar;
